var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Classes.WarningPopup = new Class({
    Extends: OCS.Classes.MooPopup,
    debug: false,
    options: {
        popup_id: 'warning_popup',
        popup_template_fields: {
            popup_wrapper_class: 'popup_wrapper warning_popup_container',
            popup_container_class: 'popup_container', // The class for the container
            popup_content_container_class: 'popup_content_container', // The class for the content container 
        },
        popup_template: '<div class="{{popup_wrapper_class}}"><div class="{{popup_container_class}}"><div class="{{popup_content_class}}">{{{popup_close_content}}}<div class="{{popup_content_container_class}}"><pre>{{{popup_content}}}</pre></div></div></div></div>',
        popup_template_close: '<div class="{{popup_close_container_class}}">Click the red "x" or press "esc" to close<div class="{{popup_close_button_class}}"></div></div>',
    },
    make_request: function (url) {
        if (url && typeof (url) !== "undefined" && url !== '') {
            var am = OCS.Functions.get_ajax_manager();
            var req = am.request(url);
            if (req) {
                req.addEvent('success', this.process_request.bind(this));
                req.send();
            } else {
                am.request(url, {
                    'url': url,
                    onSuccess: this.process_request.bind(this),
                    method: "get",
                    storeCompletedReq: 1
                }).send();
            }
        }
    },
    process_request: function (response_obj) {
        if (response_obj && response_obj.text) {
            this.process_form(response_obj.text);
        }
    }
});